import keyBy from 'lodash/keyBy';
import type { TicketType, IssueType, Group, RequestTypeCategory } from '../../common/types.tsx';

export const FILTER_BY_NO_GROUPS_GROUP_ID = -1;

export const filterTicketTypesByIssueTypes = (
	ticketTypes: TicketType[],
	issueTypes: Partial<IssueType>[],
): TicketType[] => {
	if (issueTypes.length === 0) {
		return ticketTypes;
	}
	const issueTypesSet = keyBy(issueTypes, 'id');
	return ticketTypes.filter((ticketType) => issueTypesSet[ticketType.issueType]);
};

export const filterTicketTypesByGroups = (
	ticketTypes: TicketType[],
	groupsFilter: Group[],
): TicketType[] => {
	if (groupsFilter.length === 0) {
		return ticketTypes;
	}
	const groupsSet = keyBy(groupsFilter, 'id');
	return ticketTypes.filter((ticketType) => {
		const { groups } = ticketType;
		const isCheckForItemsWithNoGroups = Boolean(groupsSet[FILTER_BY_NO_GROUPS_GROUP_ID]);

		if (isCheckForItemsWithNoGroups && groups.length === 0) {
			return true;
		}

		return groups.some((group) => groupsSet[group.id]);
	});
};

export const filterTicketTypesByCategory = (
	ticketTypes: TicketType[],
	categories: RequestTypeCategory[],
): TicketType[] => {
	if (categories.length === 0) {
		return ticketTypes;
	}

	const categorySet = keyBy(categories, 'id');

	return ticketTypes.filter((ticketType) => {
		const { category } = ticketType;

		if (!category) {
			return false;
		}

		return categorySet[category.id];
	});
};

export const filterTicketTypesByText = (ticketTypes: TicketType[], text: string): TicketType[] => {
	if (!text) {
		return ticketTypes;
	}
	const lowercaseText = text.trim().toLocaleLowerCase();
	return ticketTypes.filter(({ name, description }) =>
		`${name} ${description}`.toLocaleLowerCase().includes(lowercaseText),
	);
};

export const filterUnmappedRequestType = (requestTypes: TicketType[] | null): TicketType[] => {
	if (!requestTypes) {
		return [];
	}
	return requestTypes.filter(({ practices }) => practices.length === 0);
};
